import * as Style from './styles'
import Dropdown from 'react-bootstrap/Dropdown';
import iconActions from '../../assets/AddressList/iconActions.svg'
import { useHistory } from 'react-router-dom';
import PersonService from '../../services/person';
import { getToken } from '../../services/auth';

export const Popup = (props) => {
    const link = useHistory();
    const visibleAddress = () => {
        props.setIsVisible(!props.isVisible)
        props.setAddressOne(props.listItem)
    }

    const pushUrl = () => {
        props.setAddresOne([props.listItem])
        link.push(`/endereco/${props.listItem.id}`);
        props.setIsVisibleAddress(true)
    }

    const cancelAddress = async () => {
        try {
            const cnpj = getToken('CNPJ');
            const service = new PersonService();
            const result = await service.cancelAddress({
                cnpj,
                id_endereco_entrega:props.listItem.id
            });

            if(result.success) {
                const {data } = await props.getOne(props.listItem.id_pessoa);
                let {rows} = props.address[0]
                rows = data[0].endereco_entrega
                props.address[0].rows = rows
                props.setAddress([...props.address])
            }
    
        } catch (error) {
            
        }

    }

    return(
        <Style.Container>
            <Dropdown>
                <Dropdown.Toggle variant='none' bsPrefix={'my-css'}>
                    <img src={iconActions} alt='três pontos'/>
                </Dropdown.Toggle>
                <Dropdown.Menu  
                    popperConfig={{
                        strategy: "fixed",
                        modifiers: [
                            { name: "preventOverflow", options: { boundary: "viewport" } }
                        ]
                    }}
                >
                    <Dropdown.Item onClick={() => visibleAddress()}>Vizualizar</Dropdown.Item>
                    <Dropdown.Item onClick={() => pushUrl()}>Editar</Dropdown.Item>
                    <Dropdown.Item onClick={() => cancelAddress()}>Excluir</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </Style.Container>
    )
}